module.exports = {"431381001":"冷水江街道","431381002":"锡矿山街道","431381003":"沙塘湾街道","431381004":"布溪街道","431381100":"禾青镇","431381102":"渣渡镇","431381103":"铎山镇","431381105":"三尖镇","431381106":"金竹山镇","431381205":"中连乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431381.json
// module id = 1933
// module chunks = 0